var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19.616,
    viewBox: "0 0 16 19.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(-3.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(3.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M16.574,20.958H5.726A2.579,2.579,0,0,1,3.15,18.382V5.726A2.579,2.579,0,0,1,5.726,3.15H7.534a.768.768,0,1,1,0,1.537H5.726a1.041,1.041,0,0,0-1.04,1.04V18.382a1.041,1.041,0,0,0,1.04,1.04H16.574a1.041,1.041,0,0,0,1.04-1.04V5.726a1.041,1.041,0,0,0-1.04-1.04H14.766a.768.768,0,1,1,0-1.537h1.808A2.579,2.579,0,0,1,19.15,5.726V18.382A2.579,2.579,0,0,1,16.574,20.958Z",
    transform: "translate(-3.15 -1.342)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    d: "M.822-.85H6.246A1.674,1.674,0,0,1,7.918.822V2.63A1.674,1.674,0,0,1,6.246,4.3H.822A1.674,1.674,0,0,1-.85,2.63V.822A1.674,1.674,0,0,1,.822-.85ZM6.246,2.766a.136.136,0,0,0,.136-.136V.822A.136.136,0,0,0,6.246.687H.822A.136.136,0,0,0,.687.822V2.63a.136.136,0,0,0,.136.136Z",
    transform: "translate(4.466 0.85)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignWork);
export default __webpack_public_path__ + "static/media/assignWork.823e12dc6349bea49e6802622f098a17.svg";
export { ForwardRef as ReactComponent };